package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksItemQueryDto(
    val QueryResponse: QuickbooksItemQueryResponse,
)

@Serializable
data class QuickbooksItemQueryResponse(
    val Item: List<QuickbooksItem>,
)